import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css';
import styles from'./User.module.css';

import React, { Component } from 'react';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import headerImage from './../images/modules/user.jpg';

import addIcon from './../icons/ic_add_circle.svg';
import deleteIcon from './../icons/ic_delete.svg';

import { ReactSVG } from 'react-svg';
import { UserService } from '../../../services/ApiService';

import { CPLBanner } from '../../../components/Banner';
import { LanguageContext } from '../../../i18n/LanguageContext';

import { sprintf } from 'sprintf-js';

export default class UserModule extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            mode: 'create',
            user: null,
            users: [],
            filteredUsers: [],
            hideEditor: true,
            showSavedModal: false,
            showConfirmDeleteModal: false,
            userToDelete: null
        }
        this.onClickAddUser = this.onClickAddUser.bind(this);
        this.onUserSearch = this.onUserSearch.bind(this);
        this.onUserDelete = this.onUserDelete.bind(this);
        this.onConfirmDelete = this.onConfirmDelete.bind(this);
        this.onCancelDelete = this.onCancelDelete.bind(this);
        
        this.onCancelEditor = this.onCancelEditor.bind(this);
        this.onSaveEditor = this.onSaveEditor.bind(this);
        this.hideSaveModal = this.hideSaveModal.bind(this);
        this.onUserClicked = this.onUserClicked.bind(this);
    }

    onClickAddUser() {
        this.setState({ hideEditor: true });
        setTimeout(() => {
            this.setState({ mode: 'create', hideEditor: false, user: null });
        }, 0);
    }

    hideSaveModal() {
        this.setState({ showSavedModal: false });
    }

    onUserSearch(search) {
        let users = this.state.users;
        if (!!search) {
            users = this.state.users
                .map(user => {
                    let gender;
                    if (user.sex === 'f') {
                        gender = this.context['FEMALE'];
                    } else {
                        gender = this.context['MALE'];
                    }
                    user.sexValue = gender;
                    return user;
                })
                .map(user => {
                    let status;
                    if (user.enable) {
                        status = this.context['ACTIVE'];
                    } else {
                        status = this.context['INACTIVE'];
                    }
                    user.statusValue = status;
                    return user;
                })
                .map(user => {
                    const roles = [];
                    for (let role of user.roles) {
                        let roleName = '';
                        switch (role) {
                            case 'user_admin':
                                roleName = this.context['USER_ADMIN'];
                                break;
                            case 'content_admin':
                                roleName = this.context['CONTENT_ADMIN'];
                                break;
                            case 'commerce_admin':
                                roleName = this.context['COMMERCE_ADMIN'];
                                break;
                            case 'document_admin':
                                roleName = this.context['DOCUMENT_ADMIN'];
                                break;
                            case 'email_admin':
                                roleName = this.context['EMAIL_ADMIN'];
                                break;
                            case 'feedback_admin':
                                roleName = this.context['FEEDBACK_ADMIN'];
                                break;                                
                            case 'audit_admin':
                                    roleName = this.context['AUDIT_ADMIN'];
                                    break;            
                            case 'super_admin':
                                roleName = this.context['SUPER_ADMIN'];
                                break;
                            default: break;
                        }
                        roles.push(roleName);
                    }

                    user.rolesName = roles;
                    return user;
                })
                .filter(user => this.filterUsers(search, user, [
                    'name',
                    'lastName',
                    'organization',
                    'jobTitle',
                    'statusValue'
                ]));
        }

        this.setState({ filteredUsers: users })
    }

    filterUsers(search, user, properties) {
        for (let prop of properties) {
            switch(prop) {
                case 'rolesName':
                    for(let role of user.rolesName) {
                        if (RegExp(`(.)*${search}(.)*`, 'i').test(role)) {
                            return true;
                        }
                    }
                    break;
                case 'statusValue':
                    if (RegExp(`^${search}(.)*`, 'i').test(user.statusValue)) {
                        return true;
                    }
                    break;
                default:
                    if (RegExp(`(.)*${search}(.)*`, 'i').test(user[prop])) {
                        return true;
                    }
            }
        }
        return false;
    }

    onConfirmDelete(user) {
        this.setState({
            userToDelete: user,
            showConfirmDeleteModal: true
        });
    }

    onCancelDelete() {
        this.setState({
            userToDelete: null,
            showConfirmDeleteModal: false
        });
    }

    onUserDelete(user) {
        UserService.deleteUser(user.UserID)
            .then(async () => {
                this.setState({
                    userToDelete: null,
                    showConfirmDeleteModal: false,
                    hideEditor: true
                });
                await this.getUsers();
            })
            .catch(e => console.error(e));
    }

    onUserClicked(user) {
        this.setState({ hideEditor: true });
        setTimeout(() => {
            this.setState({ mode: 'update', hideEditor: false, user: user });
        }, 0);
    }

    onCancelEditor() {
        this.setState({ hideEditor: true });
    }

    onSaveEditor(user, mode) {
        if (mode === 'create') {
            this.createUser(user)
                .then(() => {
                    this.setState({ hideEditor: true, showSavedModal: true, saveMode: mode });
                })
                .catch(err => console.error(err));
        } else if (mode === 'update') {
            this.updateUser(user)
                .then(() => {
                    this.setState({ hideEditor: true, showSavedModal: true, saveMode: mode });
                })
                .catch(err => console.error(err));
        }
    }

    async createUser(user) {
        await UserService.createUser(user);
        await this.getUsers();
    }

    async updateUser(user) {
        await UserService.updateUser(user);
        await this.getUsers();
    }

    async componentDidMount() {
        await this.getUsers();
    }

    async getUsers() {
        let users = await UserService.getUsers();
        this.setState({ users: users, filteredUsers: users });
    }

    render() {
        let userEditor = null;
        if (!this.state.hideEditor) {
            userEditor = <UserEditor
                onSave={this.onSaveEditor}
                onCancel={this.onCancelEditor}
                onDelete={this.onConfirmDelete}
                mode={this.state.mode}
                user={this.state.user} />
        }

        let modalTitle = '';
        let modalContent = '';
        if (this.state.saveMode === 'create') {
            modalTitle = this.context['USER_CREATED_TITLE'];
            modalContent = this.context['USER_CREATED_SUCCESS_MESSAGE'];
        } else if (this.state.saveMode === 'update') {
            modalTitle = this.context['USER_UPDATED_TITLE'];
            modalContent = this.context['USER_UPDATED_SUCCESS_MESSAGE'];
        }

        return <div className="col-md-12">
            <div className="row banner-wrapper">
                <div className="col-md-12">
                    <CPLBanner
                        img={headerImage}
                        content={this.context['USER_ADMIN_MODULE_NAME']} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-8 col-md-7">
                    
                    <UserAdmin
                        onSearch={this.onUserSearch}
                        onUserClicked={this.onUserClicked}
                        users={this.state.filteredUsers}
                        onAddUser={this.onClickAddUser} />
                </div>
                <div className="col-lg-4 col-md-5">
                    {userEditor}
                </div>
            </div>
            <Modal show={this.state.showSavedModal} onHide={this.hideSaveModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalContent}</Modal.Body>
            </Modal>
            <ConfirmDeleteModal 
                user={this.state.userToDelete}
                context={this.context}
                onClose={this.onCancelDelete}
                onDelete={this.onUserDelete}
                show={this.state.showConfirmDeleteModal}/>
        </div>
    }
}

class UserAdmin extends Component {

    static contextType = LanguageContext

    constructor(props, context) {
        super(props, context);
        this.state = {
            mode: this.props.mode,
            search: '',
            confirmDeleteOpen: false,
            deleteUserIndex: null,
            deleteUser: null,
        };

        this.onSearchListener = this.onSearchListener.bind(this);
        this.onClickDeleteUser = this.onClickDeleteUser.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.confirmDeleteUser = this.confirmDeleteUser.bind(this);
    }

    onSearchListener(event) {
        this.props.onSearch(event.target.value);
        this.setState({ search: event.target.value });
    }

    onClickDeleteUser(index) {
        this.setState({ confirmDeleteOpen: true, deleteUserIndex: index, deleteUser: this.props.users[index] });
    }

    confirmDeleteUser() {
        const index = this.state.deleteUserIndex;
        this.setState({ confirmDeleteOpen: false, deleteUserIndex: null, deleteUser: null });
        this.props.onDelete(this.props.users[index]);
    }

    closeModal() {
        this.setState({ confirmDeleteOpen: false, deleteUserIndex: null, deleteUser: null });
    }

    render() {
        let userEmail = '';
        let name = '';
        if (!!this.state.deleteUser && !!this.state.deleteUser.email) {
            userEmail = this.state.deleteUser.email;
            name = `${this.state.deleteUser.name} ${this.state.deleteUser.lastName}`;
        }

        return <div>
            <div className="card">
                <div className="card-header">
                    {this.context['USERS']}
                    <span className="float-right">
                        <OverlayTrigger
                            key="top"
                            placement="top"
                            overlay={<Tooltip>{this.context['ADD']}</Tooltip>}>
                                <div className={styles['panel-button']} onClick={this.props.onAddUser}>
                                    <ReactSVG
                                        src={addIcon}
                                        className={styles['add-button']} />
                                </div>
                        </OverlayTrigger>
                    </span>
                    <span className="float-right">
                        <div className={styles['search-form']}>
                            <input type="text" value={this.state.search} onChange={this.onSearchListener} placeholder={`${this.context['SEARCH']}...`} />
                        </div>
                    </span>
                </div>
                <div className="card-body">
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th>{this.context['NAME']}</th>
                                <th>{this.context['ORGANIZATION']}</th>
                                <th>{this.context['JOB_TITLE']}</th>
                                <th>{this.context['STATUS']}</th>
                            </tr>
                        </thead>
                        <UserList
                            users={this.props.users}
                            onUserClicked={this.props.onUserClicked}
                            onDeleteListener={this.onClickDeleteUser} />
                    </table>
                </div>
            </div>
            <Modal show={this.state.confirmDeleteOpen} onHide={this.closeModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.context['USER_DELETE_CONFIRM_TITLE']}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div dangerouslySetInnerHTML={this.createMarkup(sprintf(this.context['USER_DELETE_CONFIRM_BODY'], name, userEmail))} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.closeModal}>
                        {this.context['CLOSE']}
                    </Button>
                    <Button variant="danger" onClick={this.confirmDeleteUser}>
                        {this.context['DELETE']}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    }

    createMarkup(content) {
        return {
            __html: content
        };
    };
}

const ConfirmDeleteModal = (props) => {
    if(!props.user) {
        return '';
    }

    const createMarkup = (content) => {
        return {
            __html: content
        };
    }

    const name = props.user.name;
    const email = props.user.email;
    const context = props.context;

    return <Modal show={props.show} onHide={props.onClose}>
        <Modal.Header closeButton>
            <Modal.Title>{context['USER_DELETE_CONFIRM_TITLE']}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div dangerouslySetInnerHTML={createMarkup(sprintf(context['USER_DELETE_CONFIRM_BODY'], name, email))} />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={props.onClose}>
                {context['CLOSE']}
            </Button>
            <Button variant="danger" onClick={() => props.onDelete(props.user)}>
                {context['DELETE']}
            </Button>
        </Modal.Footer>
    </Modal>
}

const UserList = (props) => {
    return <tbody>
        {props.users.map((user, index) => <UserListItem
            key={index}
            index={index}
            onUserClicked={props.onUserClicked}
            onDelete={props.onDeleteListener}
            user={user} />)}
    </tbody>
}

const UserListItem = function (props) {
    const user = props.user;

    return <tr className={styles['editor-row-clickable']} onClick={() => props.onUserClicked(user)}>
        <td>{user.name} {user.lastName}</td>
        <td>{user.organization}</td>
        <td>{user.jobTitle}</td>
        <td>
            <LanguageContext.Consumer>
                {(context) => user.enable ? <span className={styles['user-status-active']}> {context['ACTIVE']} </span> : <span className={styles['user-status-inactive']}> {context['INACTIVE']} </span>}
            </LanguageContext.Consumer>
        </td>
    </tr>
}

class UserEditor extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        let user = {
            ...{
                name: '',
                lastName: '',
                email: '',
                sex: '',
                password: '',
                organization: '',
                jobTitle: '',
                roles: []
            },
            ...props.user
        }

        if (!user.sex) {
            user.sex = '';
        }

        this.state = {
            ...user,
            ...{
                error: false,
                missingArguments: [],
                errorComponent: null,
                confirmPassword: '',
                missingArgumentsClass: {
                    name: styles['editor-form-control'],
                    lastName: styles['editor-form-control'],
                    sex: 'form-control',
                    email: styles['editor-form-control'],
                    password: styles['editor-form-control'],
                    phone: styles['editor-form-control'],
                    jobTitle: styles['editor-form-control'],
                    organization: styles['editor-form-control'],
                    roles: 'col-md-8'
                }
            }
        };

        this.onSaveUser = this.onSaveUser.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    componentDidMount() {
        if (!!this.state.roles.length) {
            for (let role of this.state.roles) {
                if (!!this.refs[role]) {
                    this.refs[role].checked = true;
                }
            }
        }
    }

    onSaveUser() {
        const { name, lastName, email, password, organization, jobTitle, UserID, sex, phone, confirmPassword } = this.state;
        let roles = {
            'user_admin': this.refs.user_admin.checked,
            'content_admin': this.refs.content_admin.checked,
            'commerce_admin': this.refs.commerce_admin.checked,
            'document_admin': this.refs.document_admin.checked,
            'email_admin': this.refs.email_admin.checked,
            'feedback_admin': this.refs.feedback_admin.checked,
            'audit_admin': this.refs.audit_admin.checked
        }

        const user = {
            UserID,
            name,
            lastName,
            email,
            phone,
            password,
            confirmPassword,
            organization,
            jobTitle,
            sex,
            roles: []
        }

        if (!!this.props.user && this.props.user.roles.includes('super_admin')) {
            user.roles.push('super_admin');
        }

        for (let role in roles) {
            if (roles.hasOwnProperty(role) && !!roles[role]) {
                user.roles.push(role);
            }
        }

        const argumentsMap = {
            name: this.context['NAME'],
            lastName: this.context['LAST_NAME'],
            sex: this.context['SEX'],
            email: this.context['EMAIL'],
            password: this.context['PASSWORD'],
            phone: this.context['PHONE'],
            jobTitle: this.context['JOB_TITLE'],
            organization: this.context['ORGANIZATION'],
            roles: this.context['ROLES']
        }

        let requiredArguments = ['name', 'lastName', 'sex', 'email', 'phone', 'jobTitle', 'organization'];

        if (this.props.mode === 'create') {
            requiredArguments.push('password');
        }

        const missingArguments = [];
        const missingArgumentsKey = [];
        for (let argument of requiredArguments) {
            if (!user[argument]) {
                missingArgumentsKey.push(argument);
                missingArguments.push(argumentsMap[argument]);
            }
        }

        if (!user.roles.length) {
            missingArgumentsKey.push('roles');
            missingArguments.push(argumentsMap['roles']);
        }

        if (!!missingArguments.length) {
            this.setState({
                error: true,
                errorComponent: this.missingArgumentsErrorComponent(missingArguments),
                missingArgumentsClass: this.getMissingArgumentMap(missingArgumentsKey)
            });
            return;
        }

        if (this.props.mode === 'create') {
            if (user.password !== user.confirmPassword) {
                this.setState({
                    error: true,
                    errorComponent: this.passwordNotMatchErrorComponent(),
                    missingArgumentsClass: this.getMissingArgumentMap(['password'])
                })
                return;
            }
        }

        if (this.props.mode === 'update') {
            if ((!!user.password || !!user.confirmPassword) && user.password !== user.confirmPassword) {
                this.setState({
                    error: true,
                    errorComponent: this.passwordNotMatchErrorComponent(),
                    missingArgumentsClass: this.getMissingArgumentMap(['password'])
                });
                return;
            }
        }

        if (!user.password.length) {
            delete user.password;
        }

        if (!user.sex) {
            delete user.sex;
        }

        user.enable = typeof this.state.enable === 'string' ? JSON.parse(this.state.enable) : this.state.enable;

        this.props.onSave(user, this.props.mode);
    }

    getMissingArgumentMap(missingArguments) {
        let missingArgumentsMap = {}
        for (let argument of missingArguments) {
            if (argument === 'sex') {
                missingArgumentsMap[argument] = 'form-control editor-form-control-error';
            } else if (argument === 'roles') {
                missingArgumentsMap[argument] = 'col-md-8 editor-form-control-error';
            } else {
                missingArgumentsMap[argument] = 'editor-form-control editor-form-control-error';
            }
        }

        return {
            ...{
                name: 'editor-form-control',
                lastName: 'editor-form-control',
                sex: 'form-control',
                email: 'editor-form-control',
                password: 'editor-form-control',
                phone: 'editor-form-control',
                jobTitle: 'editor-form-control',
                organization: 'editor-form-control',
                roles: 'col-md-8'
            },
            ...missingArgumentsMap
        }
    }

    missingArgumentsErrorComponent(missingArguments) {
        let message = ` ${missingArguments.join(', ')}`;
        return <div className={`row ${styles['editor-rows']}`}>
            <div className={`col-md-12 ${styles['editor-error-container']}`}>
                <div className={styles['editor-error-message']}>
                    <b>{this.context['MISSING_REQUIRED_ARGUMENTS_USER_EDITOR']}:</b> {message}
                </div>
            </div>
        </div>
    }

    passwordNotMatchErrorComponent() {
        let message = this.context['PASSWORD_DO_NOT_MATCH'];
        return <div className={`row ${styles['editor-rows']}`}>
            <div className={`col-md-12 ${styles['editor-error-container']}`}>
                <div className={styles['editor-error-message']}>
                    <b>{message}</b>
                </div>
            </div>
        </div>
    }

    onCancel() {
        this.props.onCancel();
    }

    onDelete() {
        this.props.onDelete(this.props.user);
    }

    componentWillUnmount() {
        console.log(`In here i should run the animation`);
    }

    toggleUserStatus = () => {
        this.setState({enable: !this.state.enable});
    }

    render() {
        let deleteButton = <span className="float-right">
            <div className={styles['user-item-icon']}>
                <OverlayTrigger
                    key="top"
                    placement="top"
                    overlay={<Tooltip>{this.context['DELETE']}</Tooltip>}>
                        <ReactSVG src={deleteIcon} className={styles['delete-button']} onClick={this.onDelete} />
                </OverlayTrigger>
            </div>
        </span>

        deleteButton = null; // TODO To enable deleteButton component remove this line

        let saveButton = <span className="float-right">
            <Button variant="success" onClick={this.onSaveUser}>
                {this.context['SAVE']}
            </Button>
        </span>

        let title;
        let statusComponent;
        if (this.props.mode === 'update') {
            title = <span>{this.context['USER_EDIT']}: <b>{this.props.user.name} {this.props.user.lastName}</b></span>
            for(let role of this.props.user.roles) {
                if(role === 'super_admin') {
                    saveButton = null;
                    deleteButton = null;
                    statusComponent = null;
                }
            }

            if(statusComponent === undefined) {
                statusComponent = <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.mandatoryOnBoth(this.context['STATUS'])}</p>
                    </div>
                    <div className="col-md-8">
                        <select
                            className='form-control'
                            value={this.state.enable}
                            onChange={(e) => this.setState({ enable: e.target.value })} >
                            <option value={true}>{this.context['ACTIVE']}</option>
                            <option value={false}>{this.context['INACTIVE']}</option>
                        </select>
                    </div>
                </div>
            }

        } else if (this.props.mode === 'create') {
            title = this.context['USER_CREATE'];
            deleteButton = null;
        }
        

        return <div className="card">
            <div className="card-header">
                {title}
                {deleteButton}
            </div>
            <div className={`card-body ${styles['editor-rows']}`}>
                {this.state.errorComponent}
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.mandatoryOnBoth(this.context['NAME'])}</p>
                    </div>
                    <div className="col-md-8">
                        <input
                            type="text"
                            className={this.state.missingArgumentsClass['name']}
                            value={this.state.name}
                            onChange={(e) => this.setState({ name: e.target.value })} />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.mandatoryOnBoth(this.context['LAST_NAME'])}</p>
                    </div>
                    <div className="col-md-8">
                        <input
                            type="text"
                            className={this.state.missingArgumentsClass['lastName']}
                            value={this.state.lastName}
                            onChange={(e) => this.setState({ lastName: e.target.value })} />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.mandatoryOnBoth(this.context['EMAIL'])}</p>
                    </div>
                    <div className="col-md-8">
                        <input
                            type="email"
                            className={this.state.missingArgumentsClass['email']}
                            value={this.state.email}
                            onChange={(e) => this.setState({ email: e.target.value })} />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.mandatoryOnBoth(this.context['PHONE'])}</p>
                    </div>

                    <div className="col-md-8">
                        <input
                            type="phone"
                            className={this.state.missingArgumentsClass['phone']}
                            value={this.state.phone}
                            onChange={(e) => this.setState({ phone: e.target.value })} />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.mandatoryOnUpdate(this.context['PASSWORD'])}</p>
                    </div>
                    <div className="col-md-8">
                        <input
                            type="password"
                            className={this.state.missingArgumentsClass['password']}
                            value={this.state.password}
                            onChange={(e) => this.setState({ password: e.target.value })} />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.mandatoryOnUpdate(this.context['CONFIRM_PASSWORD'])}</p>
                    </div>
                    <div className="col-md-8">
                        <input
                            type="password"
                            className={this.state.missingArgumentsClass['password']}
                            value={this.state.confirmPassword}
                            onChange={(e) => this.setState({ confirmPassword: e.target.value })} />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.mandatoryOnBoth(this.context['ORGANIZATION'])}</p>
                    </div>

                    <div className="col-md-8">
                        <input
                            type="text"
                            className={this.state.missingArgumentsClass['organization']}
                            value={this.state.organization}
                            onChange={(e) => this.setState({ organization: e.target.value })} />
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.mandatoryOnBoth(this.context['JOB_TITLE'])}</p>
                    </div>
                    <div className="col-md-8">
                        <input
                            type="text"
                            className={this.state.missingArgumentsClass['jobTitle']}
                            value={this.state.jobTitle}
                            onChange={(e) => this.setState({ jobTitle: e.target.value })} />
                    </div>
                </div>
                {statusComponent}
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.mandatoryOnBoth(this.context['SEX'])}</p>
                    </div>
                    <div className="col-md-8">
                        <select
                            value={this.state.sex}
                            className={this.state.missingArgumentsClass['sex']}
                            onChange={(e) => this.setState({ sex: e.target.value })} >
                            <option value=''>{this.context['SELECT']}:</option>
                            <option value="f">{this.context['FEMALE']}</option>
                            <option value="m">{this.context['MALE']}</option>
                        </select>
                    </div>
                </div>
                <div className={`row ${styles['editor-rows']}`}>
                    <div className="col-md-4">
                        <p className={styles['editor-form-control-label']}>{this.mandatoryOnBoth(this.context['ROLES'])}</p>
                    </div>
                    <div className={this.state.missingArgumentsClass['roles']}>
                        <div className="form-check">
                            <label className="form-check-label">
                                <input type="checkbox" className="form-check-input" ref="user_admin" />{this.context['USER_ADMIN']}
                            </label>
                        </div>
                        <div className="form-check">
                            <label className="form-check-label">
                                <input type="checkbox" className="form-check-input" ref="content_admin" />{this.context['CONTENT_ADMIN']}
                            </label>
                        </div>
                        <div className="form-check">
                            <label className="form-check-label">
                                <input type="checkbox" className="form-check-input" ref="commerce_admin" />{this.context['COMMERCE_ADMIN']}
                            </label>
                        </div>
                        <div className="form-check">
                            <label className="form-check-label">
                                <input type="checkbox" className="form-check-input" ref="document_admin" />{this.context['DOCUMENT_ADMIN']}
                            </label>
                        </div>
                        <div className="form-check">
                            <label className="form-check-label">
                                <input type="checkbox" className="form-check-input" ref="email_admin" />{this.context['EMAIL_ADMIN']}
                            </label>
                        </div>
                        <div className="form-check">
                            <label className="form-check-label">
                                <input type="checkbox" className="form-check-input" ref="feedback_admin" />{this.context['FEEDBACK_ADMIN']}
                            </label>
                        </div>
                        <div className="form-check">
                            <label className="form-check-label">
                                <input type="checkbox" className="form-check-input" ref="audit_admin" />{this.context['AUDIT_ADMIN']}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer">
                {saveButton}
                <span className="float-right">
                    <Button variant="danger" onClick={this.onCancel}>
                        {this.context['CANCEL']}
                    </Button>
                </span>
            </div>
        </div>
    }

    mandatoryOnBoth(text) {
        const dotStyle = {
            color: '#f00'
        }
        return <span>{text} <b style={dotStyle}>*</b></span>;
    }

    mandatoryOnUpdate(text) {
        const dotStyle = {
            color: '#f00'
        }
        if (this.props.mode === 'create') {
            return <span>{text} <b style={dotStyle}>*</b></span>;
        }

        return text;
    }
}